import type { PrimaryEvidenceType } from "@enrein/shared-contracts";

export interface GuidedStudioDemoPreset {
  readonly id: string;
  readonly label: string;
  readonly businessName: string;
  /** Shown in New project — email or phone */
  readonly contact: string;
  readonly projectType: string;
  readonly primaryPhone: string;
  readonly primaryEmail: string;
  readonly services: readonly string[];
  readonly serviceAreas: readonly string[];
  readonly description: string;
  readonly primaryEvidenceType?: PrimaryEvidenceType;
}

export const GUIDED_STUDIO_DEMO_PRESETS: readonly GuidedStudioDemoPreset[] = [
  {
    id: "electrical",
    label: "BrightSpark Electrical",
    businessName: "BrightSpark Electrical Services",
    contact: "hello@brightspark.demo",
    projectType: "Electrical",
    primaryPhone: "(415) 555-0124",
    primaryEmail: "hello@brightspark.demo",
    services: [
      "Electrical Repairs",
      "Panel Upgrades",
      "EV Charger Installation",
      "Lighting Installation",
      "Safety Inspections",
    ],
    serviceAreas: ["San Francisco", "Oakland", "Berkeley", "Daly City", "South San Francisco"],
    description:
      "Licensed residential and commercial electricians serving the Bay Area since 2012. Same-day emergency service available.",
    primaryEvidenceType: "license_or_certification",
  },
  {
    id: "plumbing",
    label: "BayFlow Plumbing",
    businessName: "BayFlow Plumbing & Drain",
    contact: "(510) 555-0198",
    projectType: "Plumbing",
    primaryPhone: "(510) 555-0198",
    primaryEmail: "service@bayflow.demo",
    services: ["Drain Cleaning", "Water Heater Repair", "Leak Detection", "Pipe Replacement", "Emergency Plumbing"],
    serviceAreas: ["Oakland", "Alameda", "Emeryville", "Berkeley"],
    description: "Family-owned plumbing team specializing in fast drain clears and water heater installs across the East Bay.",
    primaryEvidenceType: "license_or_certification",
  },
  {
    id: "hvac",
    label: "Summit Air HVAC",
    businessName: "Summit Air Heating & Cooling",
    contact: "book@summitair.demo",
    projectType: "HVAC",
    primaryPhone: "(628) 555-0142",
    primaryEmail: "book@summitair.demo",
    services: ["AC Repair", "Furnace Tune-Up", "Duct Cleaning", "Heat Pump Install", "Indoor Air Quality"],
    serviceAreas: ["San Jose", "Santa Clara", "Sunnyvale", "Mountain View"],
    description: "Licensed HVAC technicians for repair, maintenance, and energy-efficient system upgrades in Silicon Valley.",
    primaryEvidenceType: "professional_credentials",
  },
] as const;

export function findGuidedDemoPreset(id: string): GuidedStudioDemoPreset | undefined {
  return GUIDED_STUDIO_DEMO_PRESETS.find((preset) => preset.id === id);
}
